// User Control API

import { createAsyncThunk } from "@reduxjs/toolkit";
import { OpfUrl, SSOApi, UsmApi } from "../http-common";
import { IUserFilterModel } from "../../slices/UserControlSlice";
import { API_SSO } from "./SSOapi";

export interface ILock_UnlockAccount {
    userID: string;
    account: string;
    performedBy: string;
}

export interface ISubmitTempPassword {
    emailID: string;
    clientID: string;
    tempPassword: string;
}

export interface IChangePassword {
    emailID: string;
    clientID: string;
    oldPassword: string;
    newPassword: string;
}

export interface IValidateLogin {
    emailID: string;
    clientID: string;
    Password: string;
}

export interface IUpdateSSOUser {
    emailID: string;
    isSSoUser: boolean;
    userRoles: string[];
}


export const API_UserControl = {
    GetPartnerTypeForOPF : (emailID: string) => {
        return OpfUrl.get(`Login/PartnerRoles?emailId=${emailID}`);
    },
    GetPartnerType: (emailID: string) => {
        return UsmApi.get(`Resource/GetUserDetailsForSSONotification?emailID=${emailID}`)
    },
    GetAllApplication: () => {
        return SSOApi.get("api/applicationresources/getall");
    },
    GetAllUser: (req: IUserFilterModel) => {
        return SSOApi.post("api/usercontrol/getallusers", req);
    },
    GetUserByID: (userID: string) => {
        return SSOApi.get(`api/usercontrol/getuser-id?UserID=${userID}`);
    },
    Lock_UnlockAccount: (request: ILock_UnlockAccount) => {
        return SSOApi.put(
            `api/usercontrol/lock-unlockuser?userID=${request.userID}&account=${request.account}&performedBy=${request.performedBy}`
        );
    },
    RemoveUserByID: (userID: string) => {
        return SSOApi.delete(`api/usercontrol/remove-userbyid?userId=${userID}`);
    },
    GeneratePassword: () => {
        return SSOApi.put("api/usercontrol/generatepassword");
    },
    SubmitTempPassword: (request: ISubmitTempPassword) => {
        return SSOApi.put(
            `api/usercontrol/submittemppassword?emailID=${request.emailID}&clientID=${request.clientID}&tempPassword=${request.tempPassword}`
        );
    },
    ChangePassord: (request: IChangePassword) => {
        return SSOApi.put(
            `api/usercontrol/changepassword?emailId=${request.emailID}&clientID=${request.clientID}&oldPassword=${request.oldPassword}&newPassword=${request.newPassword}`
        );
    },
    ValidatePasswordLogin: (request: IValidateLogin) => {
        return SSOApi.post(
            `api/usercontrol/validatepassword-login?emailID=${request.emailID}&password=${request.Password}}&clientID=${request.clientID}`
        );
    },
    GetResources: () => {
        return SSOApi.get("api/resources/getall");
    },
    UpdateSSOUserRole: (req: IUpdateSSOUser) => {
        return SSOApi.put("api/usercontrol/update-ssouser-role", req);
    },
    getAssignUser: (type: string) => {
        return SSOApi.get(`api/usercontrol/get-assign-user?type=${type}`)
    }
};

export const getAssignUser = createAsyncThunk("SSOUser/getAssignUser", async (type: string) => {
    try {
        const response = await API_UserControl.getAssignUser(type);
        return response.data.data;
    } catch (err) {
        console.log("get Assign User" + err);
    }
});


export const UpdateSSOUserRole = createAsyncThunk("SSOUser/UpdateSSOUserRole", async (req: IUpdateSSOUser) => {
    try {
        const response = await API_UserControl.UpdateSSOUserRole(req);
        return response.data.data;
    } catch (err) {
        console.log("Update SSO User Role" + err);
    }
});

export const GetPartnerType = createAsyncThunk("SSOUser/UpdatePartnerType", async (emailID: string) => {
    try {
        const response = await API_UserControl.GetPartnerType(emailID);
        return response.data.data;
    } catch (err) {
        console.log("Update Partner type" + err);
    }
});

export const GetPartnerTypeForOPF = createAsyncThunk("SSOUser/UpdatePartnerTypeForOpf", async (emailID: string) => {
    try {
        const response = await API_UserControl.GetPartnerTypeForOPF(emailID);
        console.log(response.data)
        return response.data;
    } catch (err) {
        console.log("Update Partner OPF type" + err);
    }
});


export const GetResources = createAsyncThunk("SSOUser/GetResources", async () => {
    try {
        const response = await API_UserControl.GetResources();
        return response.data.data.resources;
    } catch (err) {
        console.log("Get All SSO Resources" + err);
    }
});

// Get All User to Display in User Control
export const GetAllUser = createAsyncThunk("SSOUser/GetAll", async (req: IUserFilterModel) => {
    try {
        const response = await API_UserControl.GetAllUser(req);
        return response.data.data;
    } catch (err) {
        console.log("Get All SSO User" + err);
    }
});

//Get All the Application
export const GetAllApplication = createAsyncThunk("SSO/Application", async () => {
    try {
        const response = await API_UserControl.GetAllApplication();
        return response.data.data;
    }
    catch (err) {
        console.log("Get All Application Resource" + err);
    }
})

export const Lock_UnlockAccount = createAsyncThunk(
    "SSOUser/Lock_UnlockAccount",
    async (request: ILock_UnlockAccount) => {
        try {
            const response = await API_UserControl.Lock_UnlockAccount(request);
            return response.data;
        } catch (err) {
            console.log("Lock/Unlock SSOUser" + err);
        }
    }
);

export const RemoveUserByID = createAsyncThunk(
    "SSOUser/RemoveUser",
    async (UserID: string) => {
        try {
            const response = await API_UserControl.RemoveUserByID(UserID);
            return response.data;
        } catch (err) {
            console.log("Remove User by ID" + err);
        }
    }
);
